import React, { Component, Suspense, lazy } from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import Spinner from "../app/shared/Spinner";
import Admintickettrack from "./Pages/SupportTicket/Admin/Admintickettrack";
import RequireAuth from "../Util/RequireAuth";
import SecureLS from "secure-ls";
// import LotList from "./Pages/LotList.jsx";

const Dashboard = lazy(() => import("./dashboard/Dashboard"));
const Adminlist = lazy(() => import("./Pages/List/Adminlist"));
const Createretailer = lazy(() =>
  import("./Pages/Registration/Createretailer")
);
//
const CreateDistributor = lazy(() =>
  import("./Pages/Registration/CreateDistributor")
);

const VaAccountDetails = lazy(() => import("./Pages/VaAccountDetails"));
const Createusercard = lazy(() =>
  import("./Pages/Registration/Createusercard")
);
const CreateBulkUser = lazy(() =>
  import("./Pages/Registration/CreateBulkCard")
);
const bulkFileHistory = lazy(() =>
  import("./Pages/Registration/BulkFileHistory")
);
const CreateBulkInventory = lazy(() =>
  import("./Pages/Registration/CreateBulkInventory")
);
const Retailerlist = lazy(() => import("./Pages/List/Retailerlist"));
const Bulkregistration = lazy(() => import("./Pages/Bulkregistration"));
const BulkfileList = lazy(() => import("./Pages/Bulkfilelist"));
const Adminrequestmanage = lazy(() => import("./Pages/Adminrequestmanage"));
const Reversefund = lazy(() => import("./Pages/Reversefund"));
const Cardtopupreport = lazy(() => import("./Pages/Report/Cardtopupreport"));
const TransactionReport = lazy(() =>
  import("./Pages/Report/TransactionReport")
);
// topup report menu-rem
const WallettransactionReport = lazy(() =>
  import("./Pages/Report/Wallettransactionreport")
);
const RetailerSupport = lazy(() =>
  import("./Pages/SupportTicket/Retailer/Retailersupport")
);
const AdminSupport = lazy(() =>
  import("./Pages/SupportTicket/Admin/Adminsupport")
);
// const ConsolidatedLedger = lazy(() =>
//   import("./Pages/Report/ConsolidatedLedger")
// );
const Userslist = lazy(() => import("./Pages/Users"));
const lotgenerate = lazy(() => import("./Pages/LotManagement/LotGenerate.jsx"));

const PhysicalCardMapping = lazy(() =>
  import("./Pages/KitMapping/PhysicalCardMapping.jsx")
);
const PhysicalCardMappingRemove = lazy(() =>
  import("./Pages/KitMapping/PhysicalCardMappingRemove.jsx")
);
const dispatchFailedLots = lazy(() =>
  import("./Pages/LotManagement/DispatchFailedLots.jsx")
);
const FetchLots = lazy(() => import("./Pages/LotManagement/FetchLots.jsx"));

// const DispatchToBranch = lazy(() =>
//   import("./Pages/LotManagement/DispatchToBranch.jsx")
// );
const InventoryReport = lazy(() => import("./Pages/InventoryReport"));
const AvailableInventoryReport = lazy(() =>
  import("./Pages/AvailableInventoryReport")
);
const ProfilePage = lazy(() => import("./Pages/ProfilePage"));

const DistributorPending = lazy(() => import("./Pages/DistributorPending"));

const CardsList = lazy(() => import("./Pages/Cards"));
const Retailerrequest = lazy(() => import("./Pages/retailerrequest"));
const Retailertickettrack = lazy(() =>
  import("./Pages/SupportTicket/Retailer/Reteailertickettrack")
);
const Changepassword = lazy(() =>
  import("./Pages/PasswordManage/Changepassword")
);
const ResetPasswordConfirm = lazy(() =>
  import("./Pages/PasswordManage/ResetConfirmpassword")
);
const Registrationconfirm = lazy(() =>
  import("./Pages/Registration/RegistrationConfirm")
);
const CardTransaction = lazy(() => import("./Pages/List/CardTransactionList"));
const CardCreationRequest = lazy(() =>
  import("./Pages/Registration/CardCreationRequest")
);
const CrardTEsting = lazy(() => import("./Pages/testingforcard"));

const Asynnotfound = lazy(() => import("./Pages/Notfound"));

const Login = lazy(() => import("./user-pages/Login"));
// const CardBalance = lazy(() => import("./Pages/List/CardBalance"));
const BulkReversal = lazy(() => import("./Pages/BulkReversal"));
// const CardReplacementReport = lazy(() =>
//   import("./Pages/Report/CardReplacementReport")
// );
// const CardActiveInactive = lazy(() =>
//   import("./Pages/Report/CardActiveInactive")
// );
// const FundingReport = lazy(() => import("./Pages/Report/FundingReport"));
const VaTransactions = lazy(() => import("./Pages/AdminConfig/VaTransactions"));
const BankAccountMapping = lazy(() =>
  import("./Pages/AdminConfig/BankAccountMapping")
);
const ProductMapping = lazy(() => import("./Pages/AdminConfig/ProductMapping"));
const transactionmap = lazy(() =>
  import("./Pages/AdminConfig/TransactionMap.jsx")
);
// const EscrowReport = lazy(() => import("./Pages/Report/EscrowReport"));
const UserCards = lazy(() => import("./Pages/Approval/UserCards"));
const CardInventory = lazy(() => import("./Pages/Approval/CardInventory"));
const BalanceCheck = lazy(() => import("./Pages/Approval/BalanceCheck"));

var ls = new SecureLS();
let jwttoken = ls.get("key1")?.jwtToken;
let isAuth = !!jwttoken;

class AppRoutes extends Component {
  render() {
    return (
      <Suspense fallback={<Spinner />}>
        <Switch>
          {/* <Route exact path="/" component={Login} /> */}
          <Route
            exact
            path="/"
            render={(props) =>
              isAuth ? <Redirect to="/dashboard" /> : <Login {...props} />
            }
          />
          {/* <Route exact path="/">
            {jwttoken ? <Redirect to="/dashboard" /> : <Login />}
          </Route> */}

          <Route path="/dashboard" component={Dashboard} />

          <RequireAuth
            path="/distributorpendingforapproval"
            component={DistributorPending}
            requiredUserType="ADMIN"
          />
          {/* <RequireAuth path="/dashboard" component={Dashboard} /> */}
          <RequireAuth
            exact
            path="/retailerlist"
            component={Retailerlist}
            requiredUserType="ADMIN"
          />
          <RequireAuth
            path="/adminlist"
            component={Adminlist}
            requiredUserType="ADMIN"
          />
          <RequireAuth
            exact
            path="/createRetailer"
            component={Createretailer}
            requiredUserType="ADMIN"
          />
          <RequireAuth
            exact
            path="/vatransactions"
            component={VaTransactions}
            requiredUserType="ADMIN"
          />
          <RequireAuth
            exact
            path="/bankaccountmapping"
            component={BankAccountMapping}
            requiredUserType="ADMIN"
          />
          <RequireAuth
            exact
            path="/productmapping"
            component={ProductMapping}
            requiredUserType="ADMIN"
          />
          <RequireAuth
            exact
            path="/createDistributor"
            component={CreateDistributor}
            requiredUserType="ADMIN"
          />
          <RequireAuth
            exact
            path="/vaaccountdetails"
            component={VaAccountDetails}
            requiredUserType="RETAILER"
          />
          <RequireAuth
            exact
            path="/createBulkCard"
            component={CreateBulkUser}
            requiredUserType="RETAILER"
          />
          <RequireAuth
            exact
            path="/bulkfilehistory"
            component={bulkFileHistory}
            // requiredUserType="RETAILER"
          />

          <RequireAuth
            exact
            path="/createBulkInventory"
            component={CreateBulkInventory}
          />
          <RequireAuth
            exact
            path="/transactionReport"
            component={TransactionReport}
          />
          <RequireAuth
            exact
            path="/createCard"
            component={Createusercard}
            requiredUserType="RETAILER"
          />

          <RequireAuth
            exact
            path="/bulkregistration"
            component={Bulkregistration}
          />
          <RequireAuth exact path="/bulkfilelist" component={BulkfileList} />
          <RequireAuth
            exact
            path="/adminrequestmanage"
            component={Adminrequestmanage}
          />
          <RequireAuth
            exact
            path="/adminreversefund"
            component={Reversefund}
            requiredUserType="ADMIN"
          />
          <RequireAuth
            exact
            path="/cardtopupreport"
            component={Cardtopupreport}
          />
          {/* topup report menu-rem */}
          <RequireAuth
            exact
            path="/wallettransactionreport"
            component={WallettransactionReport}
          />
          <RequireAuth
            exact
            path="/retailerSupport"
            component={RetailerSupport}
          />
          {/* <RequireAuth
            exact
            path="/consolidated-ledger"
            component={ConsolidatedLedger}
          /> */}
          <RequireAuth
            exact
            path="/adminSupport"
            component={AdminSupport}
            requiredUserType="ADMIN"
          />
          {/* // admin support  menu-rem   */}
          <RequireAuth exact path="/users" component={Userslist} />
          <RequireAuth
            exact
            path="/lotgenerate"
            component={lotgenerate}
            requiredUserType="ADMIN"
          />
          <RequireAuth
            exact
            path="/transactionmap"
            component={transactionmap}
            requiredUserType="ADMIN"
          />
          <RequireAuth
            exact
            path="/kitmapping"
            component={PhysicalCardMapping}
            requiredUserType="ADMIN"
          />
          <RequireAuth
            exact
            path="/kitmappingdelink"
            component={PhysicalCardMappingRemove}
            requiredUserType="ADMIN"
          />

          <RequireAuth
            exact
            path="/fetchlots"
            component={FetchLots}
            requiredUserType="ADMIN"
          />
          <RequireAuth
            exact
            path="/dispatchFailedLots"
            component={dispatchFailedLots}
            requiredUserType="ADMIN"
          />

          <RequireAuth
            exact
            path="/inventory-report"
            component={InventoryReport}
            // requiredUserType="ADMIN"
          />
          <RequireAuth
            exact
            path="/available-inventory-report"
            component={AvailableInventoryReport}
            requiredUserType="ADMIN"
          />
          <RequireAuth
            exact
            path="/profile"
            component={ProfilePage}
            // requiredUserType="ADMIN"
          />
          {/* <RequireAuth
            exact
            path="/lotlist"
            component={LotList}
          /> */}
          <RequireAuth exact path="/cards" component={CardsList} />
          <RequireAuth
            exact
            path="/admintickettrack/:userId"
            component={Admintickettrack}
          />
          <RequireAuth
            exact
            path="/retailerrequest"
            component={Retailerrequest}
          />
          <RequireAuth
            exact
            path="/retailerticket/:userId"
            component={Retailertickettrack}
          />
          <RequireAuth
            exact
            path="/Changepassword"
            component={Changepassword}
          />
          <Route
            exact
            path="/resetPasswordConfirm"
            component={ResetPasswordConfirm}
          />
          <RequireAuth
            exact
            path="/registration/confirm"
            component={Registrationconfirm}
          />
          <RequireAuth
            exact
            path="/cardtransaction/:userId"
            component={CardTransaction}
          />

          <RequireAuth exact path="/testingforCard" component={CrardTEsting} />

          <RequireAuth
            exact
            path="/adminbulkrevarsal"
            component={BulkReversal}
            requiredUserType="ADMIN"
          />

          <RequireAuth exact path="/userCards" component={UserCards} />
          <RequireAuth exact path="/cardInventory" component={CardInventory} />
          <RequireAuth exact path="/balanceCheck" component={BalanceCheck} />
          {/* bulk rev menu-rem */}

          <RequireAuth
            exact
            path="/CardCreationRequest"
            component={CardCreationRequest}
          />
          <Route exact path="/notFound" component={Asynnotfound}></Route>
          <Redirect to="/" />
        </Switch>
      </Suspense>
    );
  }
}

export default AppRoutes;
